var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#002A69"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 7,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#002A69"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 11,
    width: 9,
    height: 2,
    rx: 1,
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignCenter);
export default __webpack_public_path__ + "static/media/Align_center.a42bccb898dac775dcd654c51a07054d.svg";
export { ForwardRef as ReactComponent };